"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewSecurityTipModal = exports.clickRating = exports.clickCloseSecurityTipModal = void 0;
// Modal Tip Security

var clickRating = exports.clickRating = function clickRating(type, name, detail, data) {
  return function (_, __, _ref) {
    var Lurker = _ref.Lurker;
    Lurker.clickRating(type, name, detail, data);
  };
};
var clickCloseSecurityTipModal = exports.clickCloseSecurityTipModal = function clickCloseSecurityTipModal(type, name, detail, data) {
  return function (_, __, _ref2) {
    var Lurker = _ref2.Lurker;
    Lurker.clickCloseSecurityTipModal(type, name, detail, data);
  };
};
var viewSecurityTipModal = exports.viewSecurityTipModal = function viewSecurityTipModal(type, name, detail, data) {
  return function (_, __, _ref3) {
    var Lurker = _ref3.Lurker;
    Lurker.viewSecurityTipModal(type, name, detail, data);
  };
};